import { useEffect, useRef } from 'react';

import { ACCESS_TOKEN, ACCESS_TOKEN_PHOENIX } from '@legacy/constants/cookies';
import Cookies from 'js-cookie';
import { posthog } from 'posthog-js';
import { AuthContextProps, useAuth } from 'react-oidc-context';

import { getAuthCookieOptions } from '@/auth/authCookies';

export const handleLogout = async (auth: AuthContextProps) => {
  try {
    posthog.reset();
    const cookieOptions = getAuthCookieOptions();
    Cookies.remove(ACCESS_TOKEN_PHOENIX, cookieOptions);
    Cookies.remove(ACCESS_TOKEN, cookieOptions);
    await auth.signoutRedirect();
  } catch (error) {
    console.error('Logout failed:', error);
  }
};

export const LogoutRoute = () => {
  const auth = useAuth();
  // Use a ref to ensure logout is only initiated once in dev strict mode
  const logoutInitiatedRef = useRef(false);

  useEffect(() => {
    if (!logoutInitiatedRef.current) {
      logoutInitiatedRef.current = true;
      handleLogout(auth);
    }
  }, [auth]);

  return null;
};
